import type { PlayGameSnapshot } from "@/pages/play/api";

import {
  MODEL_RUNTIME_ERROR_MESSAGE,
  MODEL_RUNTIME_ERROR_TITLE,
} from "@/blocks/error/ModelRuntimeErrorBlock";
import type { GameEndViewModel } from "@/blocks/game-end/types";

function colorLabel(color: string | null | undefined) {
  return color === "white" ? "White" : color === "black" ? "Black" : "Nobody";
}

export function resolveGameEnd(snapshot: PlayGameSnapshot): GameEndViewModel | null {
  const result = snapshot.result;
  if (!result) {
    return null;
  }

  const winnerLabel = colorLabel(result.winner);
  const reason = result.reason;

  if (reason === "model_error") {
    return {
      tone: "aborted",
      eyebrow: "Session aborted",
      title: MODEL_RUNTIME_ERROR_TITLE,
      subtitle: MODEL_RUNTIME_ERROR_MESSAGE,
      crest: "ERR",
    };
  }

  if (result.winner === "white" || result.winner === "black") {
    return {
      tone: result.winner === snapshot.user_color ? "victory" : "defeat",
      eyebrow: "",
      title: `${winnerLabel} won!`,
      subtitle: winnerSubtitle(winnerLabel, reason),
      crest: result.winner === "white" ? "1-0" : "0-1",
    };
  }

  return {
    tone: "draw",
    eyebrow: "",
    title: "Draw",
    subtitle: drawSubtitle(reason),
    crest: "1/2",
  };
}

function winnerSubtitle(winnerLabel: string, reason: string | null) {
  if (reason === "resign") {
    return `${winnerLabel} won by resignation`;
  }
  if (reason === "timeout") {
    return `${winnerLabel} won on time`;
  }
  if (reason === "checkmate") {
    return `${winnerLabel} won by checkmate`;
  }
  return `${winnerLabel} won`;
}

function drawSubtitle(reason: string | null) {
  if (reason === "stalemate") {
    return "Draw by stalemate";
  }
  if (reason === "threefold") {
    return "Draw by threefold repetition";
  }
  if (reason === "fifty_moves") {
    return "Draw by fifty-move rule";
  }
  if (reason === "agreement") {
    return "Draw by agreement";
  }
  return "Draw";
}
